/* Caraïbes Audio — filtres par catégorie + tris (puissance, A→Z) des collections.
   Lit les attributs data-ca-* posés sur chaque carte par snippets/ca-card-data.liquid.
   Les groupes de filtres n'apparaissent que s'ils sont utiles dans la collection affichée. */
(function () {
  'use strict';
  if (window.__caCT) return;
  window.__caCT = true;

  var MAX_AUTOLOAD = 300;
  var st = { filters: {}, sort: null, userSort: false, native: false, open: {}, items: [], groups: [], loading: false, canSort: false };
  var obs = null, timer = null;

  function $(s, c) { return (c || document).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }
  function norm(s) { return String(s || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase(); }
  function slug(s) { return norm(s).replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, ''); }
  function esc(s) { return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }
  function cap(s) { s = String(s).trim(); return s.charAt(0).toUpperCase() + s.slice(1); }
  function split(s) { return String(s || '').split('|').map(function (x) { return x.trim(); }).filter(Boolean); }
  function nums(s) {
    var out = [];
    String(s || '').replace(/\d{1,3}(?:[\s ]\d{3})+|\d+(?:[.,]\d+)?/g, function (m) {
      var n = parseFloat(m.replace(/[\s ]/g, '').replace(',', '.'));
      if (isFinite(n)) out.push(n);
      return m;
    });
    return out;
  }
  function maxNum(s) { var n = nums(s); return n.length ? Math.max.apply(null, n) : null; }
  function fmtN(n) { return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, ' '); }
  function o(label, rank) { return { key: slug(label), label: label, rank: rank == null ? 50 : rank }; }
  function bandOpt(v, edges, unit) {
    var i = 0;
    while (i < edges.length && v >= edges[i]) i++;
    var label = i === 0 ? 'Moins de ' + fmtN(edges[0]) + unit
      : i === edges.length ? 'Plus de ' + fmtN(edges[i - 1]) + unit
      : fmtN(edges[i - 1]) + ' à ' + fmtN(edges[i]) + unit;
    return o(label, i);
  }
  function uniq(list) { var seen = {}; return list.filter(function (x) { if (seen[x.key]) return false; seen[x.key] = 1; return true; }); }

  /* ---------- Lecture d'une carte ---------- */
  function info(li) {
    if (li._ca) return li._ca;
    var d = li.dataset, c = { li: li };
    c.title = d.caTitle || '';
    c.type = d.caType || '';
    c.cat = d.caCat || '';
    c.price = (parseInt(d.caPrice, 10) || 0) / 100;
    c.sale = d.caSale === '1';
    c.tg = norm(d.caTags);
    c.tt = norm(c.type + ' ' + c.cat + ' ' + c.title);
    c.base = norm(c.type + ' ' + c.cat);
    c.design = split(d.caDesign);
    c.purpose = split(d.caPurpose);
    c.feat = split(d.caFeat);
    c.mount = split(d.caMount);
    c.psrc = split(d.caPsrc);
    c.hs = split(d.caHs);
    c.mic = split(d.caMic);
    c.polar = split(d.caPolar);
    c.mixer = split(d.caMixer);
    c.p1 = d.caP1 || ''; c.p2 = d.caP2 || ''; c.p4 = d.caP4 || ''; c.p8 = d.caP8 || '';
    c.imp = d.caImp || '';
    c.v = {};
    li._ca = c;
    return c;
  }
  function isAmp(c) { return /amplificateur/.test(c.base); }
  function isHp(c) { return /casque/.test(c.base); }
  function isCable(c) { return /cable/.test(c.base); }
  function isAcc(c) { return /housse|cover|support|kit |fixation|adaptateur|flight|accessoire|bumper|couplage|pied d|cable|sac |bretelle|rack/.test(c.tt); }
  function isSpk(c) {
    if (c._spk !== undefined) return c._spk;
    return (c._spk = /enceinte|haut-parleur|caisson|array|colonne|sonorisation|moniteur|monitoring|subwoofer/.test(c.tt) &&
      !/amplificateur|console|casque|micro|interface|cable|lumi|lyre/.test(c.base) && !isAcc(c));
  }
  function powerOf(c) {
    if (c._pw !== undefined) return c._pw;
    var v = isAmp(c) ? (maxNum(c.p4) || maxNum(c.p2) || maxNum(c.p8)) : maxNum(c.p1);
    return (c._pw = v || null);
  }
  function channelsOf(c) {
    var s = c.p4 || c.p2 || c.p8 || c.p1, m = String(s).match(/(\d+)\s*[x×]\s*\d/i);
    if (!m) m = (c.type + ' ' + c.title).match(/(\d+)\s*canaux/i);
    return m ? parseInt(m[1], 10) : null;
  }
  function alpha(a, b) { return a.title.localeCompare(b.title, 'fr', { numeric: true, sensitivity: 'base' }); }

  /* Format d'une enceinte : le texte (type, catégorie, titre) prime, puis la fiche
     « Design du haut-parleur », puis les étiquettes. */
  function formatOf(c) {
    var t = c.tt, d = norm(c.design.join(' | ')), g = c.tg;
    if (/line[- ]?array|\barray\b/.test(t) || /line array/.test(d)) return o('Line array', 1);
    if (/colonne|tower|\bcolumn\b/.test(t)) return o('Colonne', 3);
    if (/caisson|subwoofer|\bsub\b|sub ?\d|subline|x-sub/.test(t)) return o('Caisson de basses', 2);
    if (/colonne/.test(d)) return o('Colonne', 3);
    if (/caisson de basses/.test(d) && !/satellite/.test(d)) return o('Caisson de basses', 2);
    if (/etagere|bibliotheque/.test(d)) return o('Enceinte d’étagère', 6);
    if (/retour|wedge/.test(t)) return o('Retour de scène', 4);
    if (/encastr|plafond/.test(t + ' ' + d)) return o('Encastrable', 5);
    if (/moniteur|monitoring|studio/.test(t)) return o('Moniteur de studio', 7);
    if (/line[- ]?array/.test(g)) return o('Line array', 1);
    if (/(^|\|)colonne|enceinte colonne|systeme colonne/.test(g)) return o('Colonne', 3);
    if (/caisson de basse|subwoofer/.test(g)) return o('Caisson de basses', 2);
    return o('Enceinte de sonorisation', 0);
  }
  function alimOf(c) {
    var t = norm(c.type + ' ' + c.title), d = norm(c.design.join(' | ')), g = c.tg;
    var tp = /passiv|passif/.test(t), ta = /activ|actif|amplifi|autoaliment|powered/.test(t);
    if (tp !== ta) return tp ? o('Passive', 2) : o('Active (amplifiée)', 1);
    var dp = /passiv/.test(d), da = /activ/.test(d);
    if (dp !== da) return dp ? o('Passive', 2) : o('Active (amplifiée)', 1);
    if (c.feat.some(function (f) { return norm(f) === 'amplificateur integre'; }) || c.psrc.length) return o('Active (amplifiée)', 1);
    var gp = /\bpassi[fv]/.test(g), ga = /\bactiv|\bactif|amplifi/.test(g);
    if (gp !== ga) return gp ? o('Passive', 2) : o('Active (amplifiée)', 1);
    return null;
  }

  /* ---------- Définition des groupes de filtres ---------- */
  var G = [
    /* Enceintes, caissons, colonnes, moniteurs */
    { id: 'format', label: 'Format', cov: 0.5, vals: function (c) { return isSpk(c) ? [formatOf(c)] : []; } },
    { id: 'alim', label: 'Actif / Passif', cov: 0.5, vals: function (c) {
      if (!isSpk(c)) return [];
      var a = alimOf(c); return a ? [a] : [];
    } },
    { id: 'taille', label: 'Taille du haut-parleur', cov: 0.4, vals: function (c) {
      if (!isSpk(c)) return [];
      var m = (c.tg + ' | ' + c.tt).match(/(?:^|[^\d.,])(\d{1,2}(?:[.,]5)?)\s?(?:pouces?|po\b|"|″|”|''|inch)/);
      if (!m) return [];
      var n = parseFloat(m[1].replace(',', '.'));
      return (n < 4 || n > 24) ? [] : [o(String(n).replace('.', ',') + '"', n)];
    } },
    { id: 'voies', label: 'Nombre de voies', cov: 0.3, vals: function (c) {
      if (!isSpk(c)) return [];
      var m = (c.tg + ' | ' + c.tt).match(/(?:^|[^\d.,])([1-4])\s?(?:voies?\b|-?way\b)/);
      return m ? [o(m[1] + ' voie' + (m[1] > 1 ? 's' : ''), parseInt(m[1], 10))] : [];
    } },
    /* Amplificateurs */
    { id: 'canaux', label: 'Nombre de canaux', cov: 0.4, vals: function (c) {
      if (!isAmp(c)) return [];
      var n = channelsOf(c);
      if (!n) return [];
      return [n >= 6 ? o('6 canaux et plus', 6) : o(n + (n > 1 ? ' canaux' : ' canal'), n)];
    } },
    /* Puissance : enceintes, amplificateurs, etc. */
    { id: 'puissance', cov: 0.4, label: function (items) {
      var amps = items.filter(isAmp).length;
      return amps > items.length / 2 ? 'Puissance par canal' : 'Puissance RMS';
    }, vals: function (c) {
      var p = powerOf(c);
      return p ? [bandOpt(p, [300, 600, 1000, 2000], ' W')] : [];
    } },
    { id: 'psrc', label: 'Alimentation', cov: 0.4, vals: function (c) {
      if (!isSpk(c)) return [];
      var out = [];
      c.psrc.forEach(function (l) {
        var n = norm(l);
        if (/batterie|rechargeable|pile/.test(n)) out.push(o('Sur batterie', 2));
        else if (/alternatif|secteur/.test(n)) out.push(o('Sur secteur', 1));
      });
      if (/batterie|battery/.test(c.tg + ' ' + c.tt)) out.push(o('Sur batterie', 2));
      return uniq(out);
    } },
    { id: 'montage', label: 'Installation', cov: 0.5, vals: function (c) {
      return isSpk(c) ? uniq(c.mount.map(function (l) { return o(cap(l), 50); })) : [];
    } },
    { id: 'fonctions', label: 'Fonctions', cov: 0.3, vals: function (c) {
      if (!isSpk(c)) return [];
      var out = [], all = c.tg + ' ' + c.tt;
      c.feat.forEach(function (l) {
        var n = norm(l);
        if (n !== 'amplificateur integre' && n !== 'reglage du volume') out.push(o(cap(l), 50));
      });
      if (/bluetooth/.test(all)) out.push(o('Bluetooth', 10));
      if (/\bdsp\b/.test(all)) out.push(o('DSP intégré', 12));
      if (/dante|aes67/.test(all)) out.push(o('Dante / AES67', 13));
      return uniq(out);
    } },
    { id: 'usage', label: 'Usage', cov: 0.4, vals: function (c) {
      return uniq(c.purpose.map(function (l) { return o(cap(l.replace(/professionel\b/i, 'professionnelle')), 50); }));
    } },
    /* Casques */
    { id: 'casque', label: 'Conception', cov: 0.4, vals: function (c) {
      if (!isHp(c)) return [];
      if (c.hs.length) return uniq(c.hs.map(function (l) { return o(cap(l), /ferm/i.test(l) ? 1 : 2); }));
      var t = norm(c.type);
      if (/semi/.test(t)) return [o('Semi-ouvert', 3)];
      if (/ouvert/.test(t)) return [o('Coques ouvertes', 2)];
      if (/ferme/.test(t)) return [o('Coques fermées', 1)];
      return [];
    } },
    { id: 'cuse', label: 'Type de casque', cov: 0.3, vals: function (c) {
      if (!isHp(c)) return [];
      var t = norm(c.type + ' ' + c.title);
      if (/studio|monitoring/.test(t)) return [o('Studio', 1)];
      if (/\bdj\b/.test(t)) return [o('DJ', 2)];
      if (/hi-?fi/.test(t)) return [o('Hi-Fi', 3)];
      return [];
    } },
    { id: 'imp', label: 'Impédance', cov: 0.3, vals: function (c) {
      var v = maxNum(c.imp);
      return (isHp(c) && v) ? [bandOpt(v, [50, 100], ' Ω')] : [];
    } },
    /* Microphones */
    { id: 'micdesign', label: 'Type de micro', cov: 0.3, vals: function (c) {
      return uniq(c.mic.map(function (l) { return o(cap(l), 50); }));
    } },
    { id: 'polar', label: 'Directivité', cov: 0.3, vals: function (c) {
      return uniq(c.polar.map(function (l) { return o(cap(l), 50); }));
    } },
    /* Consoles */
    { id: 'mixer', label: 'Type de console', cov: 0.4, vals: function (c) {
      return uniq(c.mixer.map(function (l) { return o(cap(l), 50); }));
    } },
    /* Interfaces audio */
    { id: 'connexion', label: 'Connexion', cov: 0.4, vals: function (c) {
      if (!/interface|carte son/.test(c.base + ' ' + c.tt) && !/(^|\|)carte son(\||$)/.test(c.tg)) return [];
      var t = c.tt + ' ' + c.tg, out = [];
      if (/thunderbolt/.test(t)) out.push(o('Thunderbolt', 1));
      if (/usb[- ]?c|usb ?3/.test(t)) out.push(o('USB-C / USB 3', 2));
      else if (/usb/.test(t)) out.push(o('USB', 3));
      if (/dante|avb|ethernet/.test(t)) out.push(o('Ethernet (Dante / AVB)', 4));
      if (/madi/.test(t)) out.push(o('MADI', 5));
      if (/adat/.test(t)) out.push(o('ADAT', 6));
      return out;
    } },
    /* Câbles */
    { id: 'longueur', label: 'Longueur', cov: 0.5, vals: function (c) {
      if (!isCable(c)) return [];
      var m = c.title.match(/(\d+(?:[.,]\d+)?)\s?m(?![a-zA-Z²])/);
      return m ? [bandOpt(parseFloat(m[1].replace(',', '.')), [2, 5, 10, 20], ' m')] : [];
    } },
    { id: 'connecteur', label: 'Connecteurs', cov: 0.4, vals: function (c) {
      if (!isCable(c)) return [];
      var t = c.tt, out = [];
      if (/\bxlr\b/.test(t)) out.push(o('XLR', 1));
      if (/\brca\b|cinch/.test(t)) out.push(o('RCA', 2));
      if (/jack|\btrs\b|\bts\b/.test(t)) out.push(o('Jack', 3));
      if (/speakon/.test(t)) out.push(o('Speakon', 4));
      if (/\bdmx\b/.test(t)) out.push(o('DMX', 5));
      if (/midi/.test(t)) out.push(o('MIDI', 6));
      if (/ethernet|rj ?45|cat ?[5-8]/.test(t)) out.push(o('Ethernet (RJ45)', 7));
      if (/toslink|optique/.test(t)) out.push(o('Optique (Toslink)', 8));
      if (/\bbnc\b|coax/.test(t)) out.push(o('BNC / Coaxial', 9));
      if (/\busb\b/.test(t)) out.push(o('USB', 10));
      if (/hdmi/.test(t)) out.push(o('HDMI', 11));
      return out;
    } },
    /* Famille générique (consoles, micros, lumières, contrôleurs…) */
    { id: 'type', label: 'Type de produit', cov: 0.5, lump: true, vals: function (c) {
      if (isSpk(c) || isAmp(c) || isHp(c) || isCable(c) || !c.type) return [];
      return [o(cap(c.type), 0)];
    } },
    /* Commun à toutes les familles */
    { id: 'offre', label: 'Offre', min: 1, cov: 0, vals: function (c) { return c.sale ? [o('En promotion', 0)] : []; } },
    { id: 'prix', label: 'Niveau de prix', cov: 0.5, vals: function (c, items) {
      if (!c.price) return [o('Prix sur demande', 99)];
      if (!items._pe) {
        var p = items.map(function (x) { return x.price; }).filter(Boolean).sort(function (a, b) { return a - b; });
        var p90 = p[Math.floor(p.length * 0.9)] || 0;
        items._pe = p90 <= 120 ? [10, 20, 40, 80] : p90 <= 600 ? [50, 100, 200, 400] : p90 <= 2500 ? [100, 300, 600, 1000, 2000] : [300, 1000, 2000, 5000, 10000];
      }
      return [bandOpt(c.price, items._pe, ' €')];
    } }
  ];

  function build(items) {
    var out = [];
    items._pe = null;
    G.forEach(function (g) {
      var map = {}, covered = 0, counts = {};
      items.forEach(function (c) {
        var vs = g.vals(c, items) || [];
        c.v[g.id] = vs.map(function (x) { return x.key; });
        if (vs.length) covered++;
        vs.forEach(function (x) { map[x.key] = map[x.key] || x; counts[x.key] = (counts[x.key] || 0) + 1; });
      });
      var drop = false;
      if (g.lump) {
        var others = 0;
        Object.keys(counts).forEach(function (k) {
          if (counts[k] < 2) {
            delete map[k];
            map.autres = o('Autres', 9999);
            others++;
            items.forEach(function (c) { if (c.v[g.id].indexOf(k) > -1) c.v[g.id] = ['autres']; });
          }
        });
        var real = Object.keys(map).filter(function (k) { return k !== 'autres'; }).length;
        if (real < 2 || others > covered / 2) drop = true;
      }
      var opts = Object.keys(map).map(function (k) { return map[k]; });
      var minCov = g.cov == null ? 0.4 : g.cov;
      if (drop || opts.length < (g.min || 2) || covered / (items.length || 1) < minCov) {
        items.forEach(function (c) { c.v[g.id] = []; });
        return;
      }
      opts.sort(function (a, b) { return (a.rank - b.rank) || a.label.localeCompare(b.label, 'fr', { numeric: true }); });
      out.push({ id: g.id, label: typeof g.label === 'function' ? g.label(items) : g.label, options: opts });
    });
    return out;
  }

  /* ---------- Filtrage ---------- */
  function pass(c, skip) {
    for (var id in st.filters) {
      if (id === skip) continue;
      var sel = st.filters[id];
      if (!sel || !sel.length) continue;
      var vals = c.v[id] || [];
      if (!sel.some(function (k) { return vals.indexOf(k) > -1; })) return false;
    }
    return true;
  }
  function anyFilter() { return Object.keys(st.filters).some(function (k) { return st.filters[k].length; }); }

  function apply() {
    var any = anyFilter(), shown = 0;
    st.items.forEach(function (c) {
      var ok = pass(c, null);
      c.li.classList.toggle('ca-hidden', !ok);
      if (ok && c.li.style.display !== 'none') shown++;
    });
    st.groups.forEach(function (g) {
      var counts = {};
      st.items.forEach(function (c) {
        if (pass(c, g.id)) (c.v[g.id] || []).forEach(function (k) { counts[k] = (counts[k] || 0) + 1; });
      });
      g.options.forEach(function (op) {
        var el = $('[data-ca-count="' + g.id + ':' + op.key + '"]');
        if (el) el.textContent = '(' + (counts[op.key] || 0) + ')';
        var inp = $('[data-ca-opt="' + g.id + '"][value="' + op.key + '"]');
        if (inp) inp.disabled = !inp.checked && !counts[op.key];
      });
    });
    /* Compteur de produits */
    var countEl = $('.collection-toolbar__count');
    if (countEl) {
      if (any) {
        if (countEl.getAttribute('data-ca-orig') === null) countEl.setAttribute('data-ca-orig', countEl.textContent.trim());
        countEl.textContent = shown + ' produit' + (shown > 1 ? 's' : '');
      } else if (countEl.getAttribute('data-ca-orig') !== null) {
        countEl.textContent = countEl.getAttribute('data-ca-orig');
        countEl.removeAttribute('data-ca-orig');
        var availOn = $('[data-avail-filter]:checked');
        if (availOn) availOn.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
    /* Message « aucun résultat » */
    var grid = $('[data-product-grid]'), empty = $('[data-ca-empty]');
    if (any && shown === 0 && grid) {
      if (!empty) {
        empty = document.createElement('div');
        empty.className = 'empty-state';
        empty.setAttribute('data-ca-empty', '');
        empty.innerHTML = '<p><strong>Aucun produit ne correspond à ces critères.</strong></p><p><button type="button" class="button button--outline button--small" data-ca-clear>Effacer les filtres</button></p>';
        grid.parentNode.insertBefore(empty, grid.nextSibling);
      }
    } else if (empty) { empty.parentNode.removeChild(empty); }
    var reset = $('[data-ca-reset-btn]');
    if (reset) reset.style.display = any ? '' : 'none';
  }

  /* ---------- Tri ---------- */
  function sortNow() {
    var grid = $('[data-product-grid]');
    if (!grid || !st.sort) return;
    var mode = st.sort, arr = st.items.slice();
    arr.sort(function (a, b) {
      if (mode === 'za') return alpha(b, a);
      if (mode === 'az') return alpha(a, b);
      var pa = powerOf(a), pb = powerOf(b);
      if (pa == null && pb == null) return alpha(a, b);
      if (pa == null) return 1;
      if (pb == null) return -1;
      return (mode === 'power-desc' ? pb - pa : pa - pb) || alpha(a, b);
    });
    arr.forEach(function (c) { grid.appendChild(c.li); });
  }

  function hasPower() {
    return st.items.filter(function (c) { return powerOf(c) != null; }).length;
  }

  function decide() {
    var grid = $('[data-product-grid]');
    var total = parseInt(grid.getAttribute('data-ca-total'), 10) || 0;
    st.canSort = total <= MAX_AUTOLOAD;
    if (!st.canSort) { st.sort = null; return; }
    var withPower = hasPower();
    if (st.userSort && st.sort) {
      if (/^power/.test(st.sort) && !withPower) st.sort = 'az';
      return;
    }
    var u = new URL(window.location.href), sb = u.searchParams.get('sort_by'), def = grid.getAttribute('data-ca-default-sort');
    if (st.native || (sb && def && sb !== def)) { st.sort = null; return; }
    st.sort = withPower >= st.items.length * 0.5 ? 'power-asc' : 'az';
  }

  function sortUI() {
    var sel = $('[data-sort-select]');
    if (!sel || !st.canSort) return;
    $$('[data-ca-sort]', sel).forEach(function (x) { x.parentNode.removeChild(x); });
    var list = [];
    if (hasPower() >= st.items.length * 0.3) list.push(['power-asc', 'Puissance : croissante'], ['power-desc', 'Puissance : décroissante']);
    list.push(['az', 'Nom : A → Z'], ['za', 'Nom : Z → A']);
    if (st.sort) {
      Array.prototype.slice.call(sel.options).forEach(function (x) {
        if (x.value === 'title-ascending' || x.value === 'title-descending') x.parentNode.removeChild(x);
      });
    }
    list.forEach(function (it) {
      var op = document.createElement('option');
      op.value = 'ca:' + it[0]; op.textContent = it[1]; op.setAttribute('data-ca-sort', '');
      sel.appendChild(op);
    });
    if (st.sort) sel.value = 'ca:' + st.sort;
  }

  /* ---------- Rendu des groupes dans la barre latérale ---------- */
  function render() {
    var form = $('[data-facets-form]');
    if (!form) return;
    $$('[data-ca-group], [data-ca-extra]', form).forEach(function (x) { x.parentNode.removeChild(x); });
    var anchor = $('[data-avail-group]', form) || $('.facets__head', form);
    if (!anchor) return;
    var chevEl = $('.facets__group-toggle svg', form), chev = chevEl ? chevEl.outerHTML : '';
    var last = anchor;
    function after(node) { last.parentNode.insertBefore(node, last.nextSibling); last = node; }

    st.groups.forEach(function (g, i) {
      var sel = st.filters[g.id] || [];
      var open = st.open[g.id] != null ? st.open[g.id] : (i < 4 || sel.length > 0);
      var div = document.createElement('div');
      div.className = 'facets__group' + (open ? ' is-open' : '');
      div.setAttribute('data-ca-group', g.id);
      div.setAttribute('data-facet-index', 'ca-' + g.id);
      var items = g.options.map(function (op, k) {
        return '<li class="facets__item' + (k >= 6 ? ' facets__item--extra' : '') + '"><label class="facets__label">' +
          '<input type="checkbox" data-ca-opt="' + g.id + '" value="' + esc(op.key) + '"' + (sel.indexOf(op.key) > -1 ? ' checked' : '') + '>' +
          '<span>' + esc(op.label) + '</span><span class="facets__count" data-ca-count="' + g.id + ':' + esc(op.key) + '"></span></label></li>';
      }).join('');
      var more = g.options.length > 6
        ? '<button type="button" class="facets__more"><span>Voir plus</span>' + chev + '</button>' : '';
      div.innerHTML = '<button type="button" class="facets__group-toggle" aria-expanded="' + open + '">' + esc(g.label) + chev + '</button>' +
        '<div class="facets__group-body"><ul class="facets__list' + (g.options.length > 6 ? ' facets__list--hidden-extra' : '') + '">' + items + '</ul>' + more + '</div>';
      after(div);
    });

    if (st.groups.length) {
      var extra = document.createElement('div');
      extra.className = 'ca-extra';
      extra.setAttribute('data-ca-extra', '');
      var partial = $('[data-load-more]');
      extra.innerHTML = '<button type="button" class="ca-clear" data-ca-clear data-ca-reset-btn>Effacer ces filtres</button>' +
        (partial ? '<p class="ca-note">Ces filtres portent sur les produits déjà affichés : chargez la suite de la collection pour élargir la sélection.</p>' : '');
      after(extra);
    }
    if (st.native) {
      var hid = document.createElement('input');
      hid.type = 'hidden'; hid.name = 'ca_native'; hid.value = '1';
      hid.setAttribute('data-ca-extra', '');
      form.appendChild(hid);
    }
  }

  /* ---------- Adresse (liens partageables) ---------- */
  function readUrl() {
    var u = new URL(window.location.href);
    G.forEach(function (g) {
      var v = u.searchParams.get('cf_' + g.id);
      if (v) st.filters[g.id] = v.split(',').filter(Boolean);
    });
    if (u.searchParams.get('ca_native')) st.native = true;
    var s = u.searchParams.get('ca_sort');
    if (s) { st.sort = s; st.userSort = true; }
  }
  function writeUrl() {
    var u = new URL(window.location.href);
    G.forEach(function (g) {
      var sel = st.filters[g.id];
      if (sel && sel.length) u.searchParams.set('cf_' + g.id, sel.join(','));
      else u.searchParams.delete('cf_' + g.id);
    });
    if (st.userSort && st.sort) u.searchParams.set('ca_sort', st.sort); else u.searchParams.delete('ca_sort');
    if (st.native) u.searchParams.set('ca_native', '1'); else u.searchParams.delete('ca_native');
    try { window.history.replaceState({}, '', u.toString()); } catch (e) { /* ignoré */ }
  }

  /* ---------- Chargement de toutes les pages (réutilise le bouton natif) ---------- */
  function loadAll(done) {
    var grid = $('[data-product-grid]');
    var total = grid ? parseInt(grid.getAttribute('data-ca-total'), 10) || 0 : 0;
    if (!grid || total > MAX_AUTOLOAD) return done();
    var orig = window.location.href, guard = 0;
    (function step() {
      var btn = $('[data-load-more]');
      if (!btn || guard++ > 12) { try { window.history.replaceState({}, '', orig); } catch (e) { /* ignoré */ } return done(); }
      var before = grid.children.length, href = btn.getAttribute('href'), t0 = Date.now();
      btn.click();
      (function wait() {
        var b = $('[data-load-more]');
        if (grid.children.length > before && (!b || b.getAttribute('href') !== href)) return step();
        if (Date.now() - t0 > 15000) { try { window.history.replaceState({}, '', orig); } catch (e) { /* ignoré */ } return done(); }
        setTimeout(wait, 120);
      })();
    })();
  }

  /* ---------- Cycle de mise à jour ---------- */
  function quiet(fn) {
    if (obs) obs.disconnect();
    try { fn(); } finally { if (obs) { obs.takeRecords(); watch(); } }
  }
  function watch() {
    var r = $('[data-collection-results]'), f = $('[data-facets-form]');
    if (!obs) {
      obs = new MutationObserver(function () {
        if (st.loading) return;
        clearTimeout(timer);
        timer = setTimeout(function () { refresh(); }, 60);
      });
    }
    if (r) obs.observe(r, { childList: true, subtree: true });
    if (f) obs.observe(f, { childList: true });
  }

  function refresh() {
    var grid = $('[data-product-grid]');
    if (!grid) return;
    quiet(function () {
      st.items = $$(':scope > li', grid).map(info);
      decide();
      /* Au-delà de MAX_AUTOLOAD produits, on laisse les filtres natifs (côté serveur). */
      st.groups = st.canSort ? build(st.items) : [];
      Object.keys(st.filters).forEach(function (id) {
        var g = st.groups.filter(function (x) { return x.id === id; })[0];
        st.filters[id] = g ? st.filters[id].filter(function (k) { return g.options.some(function (op) { return op.key === k; }); }) : [];
      });
      render();
      sortUI();
      sortNow();
      apply();
      writeUrl();
    });
    if (st.canSort && !grid.hasAttribute('data-ca-auto')) {
      grid.setAttribute('data-ca-auto', '1');
      if ($('[data-load-more]')) {
        st.loading = true;
        grid.parentNode.setAttribute('data-ca-loading', '');
        loadAll(function () {
          st.loading = false;
          grid.parentNode.removeAttribute('data-ca-loading');
          refresh();
        });
      }
    }
  }

  /* ---------- Évènements ---------- */
  function onChange(e) {
    var t = e.target;
    if (!t || !t.matches) return;
    if (t.matches('[data-avail-filter]')) {
      /* Le filtre de disponibilité du thème réécrit le compteur : on le resynchronise ensuite. */
      setTimeout(function () { quiet(apply); }, 0);
      return;
    }
    if (t.matches('[data-ca-opt]')) {
      e.stopPropagation(); e.stopImmediatePropagation();
      var id = t.getAttribute('data-ca-opt'), arr = st.filters[id] || [], i = arr.indexOf(t.value);
      if (t.checked && i < 0) arr.push(t.value);
      if (!t.checked && i > -1) arr.splice(i, 1);
      st.filters[id] = arr;
      quiet(function () { apply(); });
      writeUrl();
      return;
    }
    if (t.matches('[data-sort-select]')) {
      e.stopPropagation(); e.stopImmediatePropagation();
      var v = t.value;
      if (v.indexOf('ca:') === 0) {
        st.sort = v.slice(3); st.userSort = true;
        quiet(function () { sortNow(); });
        writeUrl();
      } else {
        var u = new URL(window.location.href);
        u.searchParams.set('sort_by', v);
        u.searchParams.set('ca_native', '1');
        u.searchParams.delete('page');
        u.searchParams.delete('ca_sort');
        window.location.href = u.toString();
      }
    }
  }
  function onClick(e) {
    var tg = e.target.closest && e.target.closest('[data-ca-group] .facets__group-toggle');
    if (tg) {
      var grp = tg.closest('[data-ca-group]');
      setTimeout(function () { st.open[grp.getAttribute('data-ca-group')] = grp.classList.contains('is-open'); }, 0);
    }
    if (e.target.closest && e.target.closest('[data-ca-clear]')) {
      st.filters = {};
      quiet(function () { render(); apply(); });
      writeUrl();
    }
  }

  function init() {
    if (!$('[data-product-grid]') || !$('[data-collection-results]')) return;
    readUrl();
    document.addEventListener('change', onChange, true);
    document.addEventListener('click', onClick);
    watch();
    refresh();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
